import Controller from "./corporateHoliday.controller";
import template from "./corporateHoliday.html";

const corporateHoliday = {
  template,
  controller: Controller,
};

export default corporateHoliday;



// WEBPACK FOOTER //
// ./src/pages/corporateHoliday/corporateHoliday.component.js